import { render, staticRenderFns } from "./CartSummary.vue?vue&type=template&id=1b983c4a&"
import script from "./CartSummary.vue?vue&type=script&lang=js&"
export * from "./CartSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports